import { orderStatusAddressDetailsStyles } from "@insite/content-library/Widgets/OrderStatus/OrderStatusAddressDetails";
import { css } from "styled-components";

orderStatusAddressDetailsStyles.wrapper = {
    css: css`
        display: flex;
        flex-wrap: wrap;
    `,
};

orderStatusAddressDetailsStyles.shippingAddressWrapper = {
    css: css`
        margin-right: 40px;
        @media (max-width: 450px) {
            margin-bottom: 20px;
        }
    `,
};
